export default "__VITE_ASSET__DDxPlaQa__"